import { useRegisterActions } from "kbar";
import { updateParams } from "Utils";
import { useLocation, useHistory } from "react-router-dom";

export default function KBarActions(props) {
    const location = useLocation();
    const history = useHistory();

    const kbarActions = [
        {
            id: "dashShow",
            name: "Show",
        },
        {
            id: "dashListArticles",
            parent: "dashShow",
            name: "Articles",
            keywords: "show articles",
            perform: () => {
                history.push(
                    updateParams(location, { type: "article", mediatype: null })
                );
            },
        },
        {
            id: "dashListMedia",
            parent: "dashShow",
            name: "Media",
            keywords: "show media",
            perform: () => {
                history.push(
                    updateParams(location, { type: "media", mediatype: null })
                );
            },
        },
        {
            id: "dashListPages",
            parent: "dashShow",
            name: "Pages",
            keywords: "show page",
            perform: () => {
                history.push(
                    updateParams(location, { type: "page", mediatype: null })
                );
            },
        },
        {
            id: "dashListImage",
            parent: "dashShow",
            name: "Image",
            keywords: "show image",
            perform: () => {
                history.push(
                    updateParams(location, {
                        type: "media",
                        mediatype: "image",
                    })
                );
            },
        },
        {
            id: "dashListGallery",
            parent: "dashShow",
            name: "Gallery",
            keywords: "show gallery",
            perform: () => {
                history.push(
                    updateParams(location, {
                        type: "media",
                        mediatype: "gallery",
                    })
                );
            },
        },
        {
            id: "dashListVideo",
            parent: "dashShow",
            name: "Video",
            keywords: "show video",
            perform: () => {
                history.push(
                    updateParams(location, {
                        type: "media",
                        mediatype: "video",
                    })
                );
            },
        },
        {
            id: "dashListAudio",
            parent: "dashShow",
            name: "Audio",
            keywords: "show audio",
            perform: () => {
                history.push(
                    updateParams(location, {
                        type: "media",
                        mediatype: "audio",
                    })
                );
            },
        },
        {
            id: "dashListPDF",
            parent: "dashShow",
            name: "PDF",
            keywords: "show pdf",
            perform: () => {
                history.push(
                    updateParams(location, { type: "media", mediatype: "pdf" })
                );
            },
        },
        {
            id: "dashFilter",
            name: "Filter",
        },
        {
            id: "dashFilterDraft",
            parent: "dashFilter",
            name: "Draft",
            keywords: "filter draft",
            perform: () => {
                history.push(updateParams(location, { status: "draft" }));
            },
        },
        {
            id: "dashFilterPublished",
            parent: "dashFilter",
            name: "Published",
            keywords: "filter published",
            perform: () => {
                history.push(updateParams(location, { status: "published" }));
            },
        },
        {
            id: "dashFilterScheduled",
            parent: "dashFilter",
            name: "Scheduled",
            keywords: "filter scheduled",
            perform: () => {
                history.push(updateParams(location, { status: "scheduled" }));
            },
        },
        {
            id: "dashViewGrid",
            name: "View: Grid",
            keywords: "view grid",
            perform: () => {
                history.push(updateParams(location, { view: "grid" }));
            },
        },
        {
            id: "dashViewTable",
            name: "View: Table",
            keywords: "view table",
            perform: () => {
                history.push(updateParams(location, { view: "table" }));
            },
        },
        {
            id: "dashReset",
            name: "Reset filters",
            keywords: "reset",
            perform: () => {
                history.replace(location.pathname + "?");
            },
        },
    ];

    useRegisterActions(kbarActions, [kbarActions]);

    return null;
}
